import React, { useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Items from '../items'


const grid = 8;
const getItems = count => Array.from({ length: count }, (v, k) => k).map(k => ({
    id: `item-${k}`,
    content: `item ${k}`
}));

const getListStyle = isDraggingOver => ({
    background: 'none',//isDraggingOver ? "lightblue" : "lightgrey",
    width: '100%'
});

const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    // padding: grid * 2,
    margin: `0 0 ${grid}px 0`,

    // change background colour if dragging
    background: isDragging ? "none" : "none",

    // styles we need to apply on draggables
    ...draggableStyle
});

const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
}

const SceneDragItem = (props) => {
    const dummyItems = getItems(3)
    const [items, setItems] = useState(dummyItems)
    const onDragEnd = (result) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        }
        const itemsNew = reorder(
            items,
            result.source.index,
            result.destination.index
        );

        setItems(itemsNew)
    }

    return <DragDropContext onDragEnd={onDragEnd} style={{ background: 'none', width: '100%' }} className={'test'}>
        <Droppable droppableId="droppableScenes" style={{ background: 'none', width: '100%' }}>
            {(provided, snapshot) => (
                <div
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    style={getListStyle(snapshot.isDraggingOver)}
                >
                    {items.map((item, index) => {
                        return <Draggable key={item.id} draggableId={item.id} index={index}>
                            {(provided, snapshot) => (
                                <div
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    style={getItemStyle(
                                        snapshot.isDragging,
                                        provided.draggableProps.style
                                    )}
                                >
                                    <Items id={item.id} onIncreaseTime={props.onIncreaseTime} onDecreaseTime={props.onDecreaseTime} duration={props.duration} />
                                </div>
                            )}
                        </Draggable>
                    })}
                </div>)}
        </Droppable>
    </DragDropContext>

}

export default SceneDragItem;